import styled from 'styled-components'

export const Flex = styled.div`
  display: flex;
  ${props => props.gapBetween ? `
    display: inline-flex;
    gap: ${props.gapBetween}px;
  ` : ''}
  ${props => props.justify ? `
    justify-content: ${props.justify};
  ` : ''}
  ${props => props.align ? `
    align-items: ${props.align};
  ` : ''}
  ${props => props.center ? `
    align-items: center;
    justify-content: center;
  ` : ''}

  @media screen and (min-width: 1100px) {
  }
`